module.exports = __webpack_public_path__ + "img/icon-vehicle-type-m1.02281603.svg";